import { createColumnHelper } from "@tanstack/react-table";
import { Checkbox } from "@mui/material";

const columnHelper = createColumnHelper<any>();

export const PrivateIndividualOverviewColumns = [
  columnHelper.accessor("sn", {
    header: "SN",
    cell: ({ row }) => (
      <Checkbox
        color="success"
        checked={row.getIsSelected()}
        onChange={row.getToggleSelectedHandler()}
        sx={{
          color: "#E0E0E0",
          "&.Mui-checked": {
            color: "#00B074",
          },
        }}
      />
    ),
  }),
  columnHelper.accessor("date", {
    header: "Date",
    cell: (info) => <span className="text-[#464255]">{info.getValue()}</span>,
  }),
  columnHelper.accessor("title", {
    header: "Title",
    cell: (info) => (
      <span className="text-[#464255] font-medium">{info.getValue()}</span>
    ),
  }),
  columnHelper.accessor("status", {
    header: "Status",
    cell: (info) => {
      const value = info.getValue();
      let color = "#464255";
      if (value === "Submitted") color = "#00B074";
      // Add other status colors if needed
      return (
        <span style={{ color }} className="font-medium">
          {value}
        </span>
      );
    },
  }),
  columnHelper.accessor("virtual_meeting", {
    header: "Query Status",
    cell: (info) => <span className="text-[#464255]">{info.getValue()}</span>,
  }),

  columnHelper.accessor("date_applied", {
    header: "Date Applied",
    cell: (info) => <span className="text-[#464255]">{info.getValue()}</span>,
  }),
];
